<template>
  <div class="chartElem">
    <section class="content-header">
      <h1>
        รายงานจัดอันดับรายการส่งเสริมการขาย
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <!-- <i class="fa fa-dashboard"></i> รายงานจัดอันดับรายการส่งเสริมการขาย -->
          </a>
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-6">
                              <el-form-item label="ประเภทรายการส่งเสริมการขาย" required>
                                <el-select ref="service_type" v-model="form.service_type" @change="serviceType">
                                  <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                                  <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6">
                              <el-form-item label="ประเภทการจัดอันดับ" v-if="form.service_type" required>
                                <el-select ref="report_type" v-model="form.report_type">
                                  <el-option label="ค่าบริการเหมาจ่ายตามสิทธิ์การใช้งาน (บาท)" value="price"></el-option>
                                  <el-option label="ความเร็วดาวน์โหลด (Mbps)" value="download_speed"></el-option>
                                  <el-option label="ความเร็วอัปโหลด (Mbps)" value="upload_speed" v-if="form.service_type == 'broadband'"></el-option>
                                  <el-option label="ปริมาณผู้ใช้งานแพ็กเกจ (ราย)" value="usage"></el-option>
                                  <el-option label="ปริมาณผู้เข้าชม (ครั้ง)" value="viewer"></el-option>
                                  <el-option label="ปริมาณการโทร (นาที)" value="voice_amount"  v-if="form.service_type == 'mobile'" ></el-option>
                                  <el-option label="ปริมาณการให้บริการ SMS (ข้อความ)" value="sms_amount" v-if="form.service_type == 'mobile'" ></el-option>
                                  <el-option label="ปริมาณการให้บริการ MMS (ข้อความ)" value="mms_amount" v-if="form.service_type == 'mobile'" ></el-option>
                                  <el-option label="ปริมาณอินเทอร์เน็ต (MB)" value="internet_mb" v-if="form.service_type == 'mobile'" ></el-option>
                                  <el-option label="ปริมาณอินเทอร์เน็ต (GB)" value="internet_gb" v-if="form.service_type == 'mobile'" ></el-option>
                                  <el-option label="อัตราค่าบริการเฉลี่ยบริการเสียง (บาท/นาที)" value="voice_avg" v-if="form.service_type == 'mobile'"></el-option>
                                  <el-option label="อัตราค่าบริการเฉลี่ยบริการ SMS (บาท/ข้อความ)" value="sms_avg" v-if="form.service_type == 'mobile'"></el-option>
                                  <el-option label="อัตราค่าบริการเฉลี่ยบริการ MMS (บาท/ข้อความ)" value="mms_avg" v-if="form.service_type == 'mobile'"></el-option>
                                  <el-option label="อัตราค่าบริการเฉลี่ยบริการอินเทอร์เน็ต (บาท/MB)" value="internet_avg" v-if="form.service_type == 'mobile'"></el-option>
                                  <el-option label="อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการเสียง (บาท/นาที)" value="voice_fee" v-if="form.service_type == 'mobile'"></el-option>
                                  <el-option label="อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการ SMS (บาท/ข้อความ)" value="sms_fee" v-if="form.service_type == 'mobile'"></el-option>
                                  <el-option label="อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการ MMS (บาท/ข้อความ)" value="mms_fee" v-if="form.service_type == 'mobile'"></el-option>
                                  <el-option label="อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการอินเทอร์เน็ต (บาท/MB)" value="internet_fee" v-if="form.service_type == 'mobile'"></el-option>
                                </el-select>
                              </el-form-item>
                              <el-form-item label="ประเภทการจัดอันดับ" v-if="!form.service_type">
                                <el-input :disabled="true"></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-6">
                              <el-form-item label="การเรียงลำดับ">
                                <el-radio-group v-model="form.order">
                                  <el-radio label="DESC">มากที่สุด - น้อยที่สุด</el-radio>
                                  <el-radio label="ASC">น้อยที่สุด - มากที่สุด</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6">
                              <el-form-item label="จำนวนการเปรียบเทียบ (ลำดับ)">
                                <el-radio-group v-model="form.limit">
                                  <el-radio-button label="5"></el-radio-button>
                                  <el-radio-button label="10"></el-radio-button>
                                  <el-radio-button label="15"></el-radio-button>
                                </el-radio-group>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-6">
                              <el-form-item label="ช่วงเวลาในการเปรียบเทียบ">
                                <el-select v-if="form.report_type == 'viewer'" :disabled="true">
                                  <el-option value=""></el-option>
                                </el-select>
                                <el-select v-else v-model="form.date_type" @change="changeDateType">
                                  <el-option label="ทั้งหมด" value=""></el-option>
                                  <el-option label="เดือน" value="month"></el-option>
                                  <el-option label="ไตรมาส" value="quarter"></el-option>
                                  <el-option label="ปี" value="year"></el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6" v-if="form.date_type == 'month'">
                              <el-form-item label="ช่วงเวลา" required>
                                <el-date-picker
                                v-model="form.month"
                                type="month"
                                ></el-date-picker>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6" v-if="form.date_type == 'quarter'">
                              <el-form-item label="ช่วงเวลา" required>
                                <el-select
                                style="width: 30%"
                                v-model="form.quarter_no"
                                >
                                  <el-option value="1"></el-option>
                                  <el-option value="2"></el-option>
                                  <el-option value="3"></el-option>
                                  <el-option value="4"></el-option>
                                </el-select>
                                <el-date-picker
                                @change="pickQuarter"
                                style="width: 70%"
                                v-model="form.quarter"
                                type="year"
                                ></el-date-picker>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6" v-if="form.date_type == 'year'">
                              <el-form-item label="ช่วงเวลา" required>
                                <el-date-picker
                                v-model="form.year"
                                type="year"
                                ></el-date-picker>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6" v-if="form.date_type == null">
                              <el-form-item label="ช่วงเวลาในการเปรียบเทียบ">
                                <el-input :disabled="true"></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="รูปแบบรายงาน">
                            <el-radio-group v-model="form.chart_type">
                              <el-radio label="column">Column Chart</el-radio>
                              <el-radio label="bar">Bar Chart</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="แสดงตารางข้อมูล">
                            <el-radio-group v-model="form.display_table">
                              <el-radio :label="true">แสดง</el-radio>
                              <el-radio :label="false">ไม่แสดง</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="generate()">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                  <div v-if="displayChart">
                    <div class="col-sm-12" style="text-align:right;padding-bottom: 20px">
                      <el-button type="primary" @click.prevent="exportDoc()" :disabled="pending" v-loading="pending">Export Word</el-button>
                    </div>
                  </div>
                  <div ref="printable">
                    <div ref="chart" class="box-body" v-if="displayChart">
                      <div class="col-sm-12"  v-for="chart in this.store_charts" :key="chart.id">
                        <charts :options="chart"></charts>
                      </div>
                    </div>
                    <div v-if="displayTable">
                      <table class="table table-hover table-responsive">
                        <template v-for="(tr,index) in data_table">
                          <tr v-if="index == 0" :key="index" bgcolor="#99ccff">
                            <th style="width: 65px !important">ลำดับที่</th>
                            <th v-for="th in tr" :key="th">{{th}}</th>
                          </tr>
                          <tr v-else :key="index" bgcolor="#e6f2ff">
                            <td>{{index}}</td>
                            <td v-for="td in tr" :key="td">{{td}}</td>
                          </tr>
                        </template>
                      </table>
                    </div>
                  </div>
                  <div class="box-body" v-if="displayText">
                    <div class="col-sm-12">
                      <h4 align="center">ไม่พบข้อมูลที่ต้องการค้นหา</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>

<script>
import Chart from "chart.js"
import { mapState, mapActions } from "vuex";
import { Document, Packer, Paragraph, Media, HorizontalPositionRelativeFrom, HorizontalPositionAlign, VerticalPositionRelativeFrom, VerticalPositionAlign, PageOrientation, Table, TableRow, TableCell, TextRun, WidthType, VerticalAlign, AlignmentType, BorderStyle, ShadingType} from "docx";
import { saveAs } from "file-saver";
export default {
  data () {
    return {
      loading : false,
      form: {
        service_type : null,
        report_type : null,
        order : "DESC",
        limit : 10,
        chart_type: "bar",
        date_type : null,
        month : null,
        quarter_no : null,
        quarter : null,
        year : null,
        display_table : true
      },
      label_position: "top",
      pending: false
    }
  },
  computed : {
    ...mapState({
      store_groups : store => store.Report_ranking.provider_group,
      store_providers : store => store.Report_ranking.provider_list,
      store_charts : store => store.Report_ranking.charts,
      displayChart : store => store.Report_ranking.displayChart,
      displayText : store => store.Report_ranking.displayText,
      displayTable : store => store.Report_ranking.displayTable,
      data_table : store => store.Report_ranking.data_table
    })
  },
  methods : {
    ...mapActions({
      set_chart_data : 'Report_ranking/setChartData'
    }),
    generate(){
      if(!this.form.service_type){
        this.$alert("กรุณาเลือกประเภทรายการส่งเสริมการขาย", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.service_type.focus();
          }
        });
      }else if(!this.form.report_type){
        this.$alert("กรุณาเลือกประเภทการจัดอันดับ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.report_type.focus();
          }
        });
      }else if(this.form.date_type && !this.form[this.form.date_type]){
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง"
        });
      }else{
        let tableDiv = document.querySelector('.highcharts-data-table');
        if (tableDiv) {
          tableDiv.innerHTML = ''
        }
        this.set_chart_data(this.form)
      }
    },
    serviceType(){
      this.form.report_type = null
    },
    pickQuarter(){
      this.form.quarter_no = this.form.quarter_no ? this.form.quarter_no : 1
    },
    changeDateType(){
      this.form.month = null
      this.form.quarter = null
      this.form.quarter_no = null
      this.form.year = null
    },
    exportDoc(){
      this.pending = true
      this.$html2canvas(this.$refs.printable, { canvas: null }).then(function(canvas) { console.log(canvas) })
      this.$html2canvas(this.$refs.chart, { letterRendering : true,
          canvas: null,
          onclone: function(clone) {
            clone.querySelector('.highcharts-root').style.width = '100%';
            clone.querySelector('.highcharts-root').style.height = 'auto';
            clone.querySelector('.highcharts-root').style.objectFit = 'cover';
          } 
      }).then(canvas => {
        const img = canvas.toDataURL("image/png", 1.0);
        const doc = new Document();
        var ratio = 950/canvas.width
        var height = canvas.height * ratio
        var width = canvas.width * ratio
        const image = Media.addImage(doc, img, width, height,{
            // floating: {
            //     horizontalPosition: {
            //         relative: HorizontalPositionRelativeFrom.PAGE,
            //         align: HorizontalPositionAlign.CENTER,
            //     },
            //     verticalPosition: {
            //         relative: VerticalPositionRelativeFrom.PAGE,
            //         align: VerticalPositionAlign.CENTER,
            //     },
            // }
        });
        const content = [new Paragraph({children: [image], alignment: AlignmentType.CENTER})]
        if(this.form.display_table){
          let table_rows = []
          for(let row in this.data_table){
            var index = row == 0 ? 'ลำดับที่' : row
            var fill_color = row == 0 ? { fill : "#99ccff", val : ShadingType.CLEAR, color : "auto" } : { fill : "#e6f2ff", val : ShadingType.CLEAR, color : "auto" }
            var cols = [
              new TableCell({
                  shading: fill_color,
                  borders: {
                    top: {style: BorderStyle.THICK, size: 1, color: "lightgrey"},
                    bottom: {style: BorderStyle.THICK, size: 1, color: "lightgrey"},
                    left: {style: BorderStyle.THICK, size: 1, color: "lightgrey"},
                    right: {style: BorderStyle.THICK, size: 1, color: "lightgrey"}
                  },
                  width: {size: 20, type: WidthType.PERCENTAGE},
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: index,
                          size: 14
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ] 
                })
            ]
            for(let item of this.data_table[row]){
              cols.push(
                new TableCell({
                  shading: fill_color,
                  borders: {
                    top: {style: BorderStyle.THICK, size: 1, color: "lightgrey"},
                    bottom: {style: BorderStyle.THICK, size: 1, color: "lightgrey"},
                    left: {style: BorderStyle.THICK, size: 1, color: "lightgrey"},
                    right: {style: BorderStyle.THICK, size: 1, color: "lightgrey"}
                  },
                  width: {size: 20, type: WidthType.PERCENTAGE},
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: item,
                          size: 14
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ] 
                })
              )
            }
            table_rows.push(
              new TableRow({
                  children: cols,
              })
            )
          }
          content.push(new Table({
            rows: table_rows
          }))
        }
        doc.addSection({
          size: {
            orientation: PageOrientation.LANDSCAPE,
          },
          children: content,
        });
        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "Report_promotion_ranking.docx");
            this.pending = false
        })
      });
    }
  }
}
</script>
 
<style scoped>
  input[type="color"]::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  #colorPicker {
    border: 0;
    padding: 0;
    margin: 0;
    width: 30px;
    height: 30px;
  }
  .numberInput {
    width: 30px;
  }
  table,td,th {
    border: 1px solid lightgrey !important
  }
</style>